import { createContext, useContext, useEffect, useReducer } from "react";
import { getRoundById } from "../features/api/round";
import { jsx as _jsx } from "react/jsx-runtime";
var ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["SET_LOADING"] = "SET_LOADING";
  ActionType["FINISH_LOADING"] = "FINISH_LOADING";
  ActionType["SET_ROUNDS"] = "SET_ROUNDS";
  ActionType["SET_ERROR_LIST_ROUNDS"] = "SET_ERROR_LIST_ROUNDS";
  ActionType["ADD_ROUND"] = "ADD_ROUND";
  ActionType["SET_ERROR_GET_ROUND"] = "SET_ERROR_GET_ROUND";
  ActionType["SET_ROUND_ID"] = "SET_ROUND_ID";
  return ActionType;
}(ActionType || {});
export const initialRoundState = {
  rounds: [],
  isLoading: true
};
export const RoundContext = /*#__PURE__*/createContext(undefined);
const roundReducer = (state, action) => {
  var _action$payload;
  switch (action.type) {
    case ActionType.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };
    case ActionType.FINISH_LOADING:
      return {
        ...state,
        isLoading: false
      };
    case ActionType.SET_ROUNDS:
      return {
        ...state,
        rounds: (_action$payload = action.payload) !== null && _action$payload !== void 0 ? _action$payload : [],
        listRoundsError: undefined
      };
    case ActionType.SET_ERROR_LIST_ROUNDS:
      return {
        ...state,
        rounds: [],
        listRoundsError: action.payload
      };
    case ActionType.ADD_ROUND:
      return {
        ...state,
        rounds: state.rounds.concat(action.payload),
        getRoundByIdError: undefined
      };
    case ActionType.SET_ERROR_GET_ROUND:
      return {
        ...state,
        getRoundByIdError: action.payload
      };
    case ActionType.SET_ROUND_ID:
      return {
        ...state,
        currentRoundId: action.payload
      };
    default:
      return state;
  }
};
export const RoundProvider = _ref => {
  let {
    children
  } = _ref;
  const [state, dispatch] = useReducer(roundReducer, initialRoundState);
  const providerProps = {
    state,
    dispatch
  };
  return /*#__PURE__*/_jsx(RoundContext.Provider, {
    value: providerProps,
    children: children
  });
};
function fetchRoundsById(dispatch, chainId, roundId) {
  dispatch({
    type: ActionType.SET_LOADING,
    payload: true
  });
  getRoundById(roundId, chainId).then(round => dispatch({
    type: ActionType.ADD_ROUND,
    payload: round
  })).catch(error => dispatch({
    type: ActionType.SET_ERROR_GET_ROUND,
    payload: error
  })).finally(() => dispatch({
    type: ActionType.FINISH_LOADING
  }));
}
export const useRoundById = (chainId, roundId) => {
  const context = useContext(RoundContext);
  if (context === undefined) {
    throw new Error("useRoundById must be used within a RoundProvider");
  }
  useEffect(() => {
    context.dispatch({
      type: ActionType.SET_ROUND_ID,
      payload: roundId
    });
    if (roundId) {
      const existingRound = context.state.rounds.find(round => round.id === roundId);
      if (!(existingRound !== null && existingRound !== void 0 && existingRound.token)) {
        fetchRoundsById(context.dispatch, chainId, roundId);
      }
    }
  }, [chainId, roundId]); // eslint-disable-line react-hooks/exhaustive-deps

  const round = context.state.rounds.find(round => round.id === roundId);
  return {
    round: round,
    isLoading: context.state.isLoading,
    getRoundByIdError: context.state.getRoundByIdError
  };
};